import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../../src/constants/premissions'
import { billConfirmParamsSchema, billConfirmSearchSchema } from '../../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../../src/utils/routePermissions'

export const Route = createFileRoute('/bill/confirm/$queryId')({
  validateSearch: (search) => billConfirmSearchSchema.parse(search),
  params: {
    parse: (params) => billConfirmParamsSchema.parse(params),
  },
  loaderDeps: ({ search }) => ({ shipData: search.shipData }),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    englishAllowed: true,
    permissionRequired: PERMISSION_ROLES.BILL,
  },
})
